import { useEffect } from 'react'
import { useLocation, useOutlet } from 'react-router'
import { AnimatePresence, motion } from 'motion/react'

import { EASING_BEZIER } from 'js/lib/constants'

import styles from './AnimatedOutlet.module.css'

export const magazineTransitionDuration = 0.5
const slideOffset = 25
const slideEase = EASING_BEZIER as [number, number, number, number]

const slideVariants = {
    initial: (direction: 'back' | 'forward') => ({
        opacity: 0,
        x: direction === 'forward' ? slideOffset : -slideOffset,
    }),
    animate: {
        opacity: 1,
        x: 0,
        transition: {
            duration: magazineTransitionDuration,
            ease: slideEase,
        },
    },
    exit: (direction: 'back' | 'forward') => ({
        opacity: 0,
        x: direction === 'forward' ? -slideOffset : slideOffset,
        transition: {
            duration: magazineTransitionDuration,
            ease: slideEase,
        },
    }),
}

const noAnimationVariants = {
    initial: { opacity: 1, x: 0 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 1, x: 0 },
}

const AnimatedOutlet = () => {
    const location = useLocation()
    const element = useOutlet()
    const direction = location.state?.direction as
        | 'back'
        | 'forward'
        | undefined

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [location.pathname])

    const variants = direction ? slideVariants : noAnimationVariants

    return (
        <div className={styles.outletWrapper}>
            <AnimatePresence mode="sync" initial={false} custom={direction}>
                {element && (
                    <motion.div
                        key={location.pathname}
                        variants={variants}
                        custom={direction}
                        initial="initial"
                        animate="animate"
                        exit="exit"
                        transition={
                            direction
                                ? {
                                      duration: magazineTransitionDuration,
                                      ease: slideEase,
                                  }
                                : { duration: 0 }
                        }
                    >
                        {element}
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    )
}

export default AnimatedOutlet
